import { BookEnum } from '@interfaces/BookEnum'
import { CategoryType } from '@models/category/CategoryType'
import { Expose, Type, Transform } from 'class-transformer'
import { BookChapterPurchaseType } from './BookChapterPurchaseType'

class UserType {
  @Expose() avatarImgPath: string

  @Expose() isPermanentBan: boolean
}

class PenNameType {
  @Expose() firstPenName: string

  @Expose()
  @Type(() => UserType)
  user: UserType
}

export class BookPurchaseType {
  @Expose() title: string

  @Expose({ name: 'coverImgPath' }) imageUrl: string

  @Expose({ name: 'cover' }) content: string

  @Expose() isEnded: boolean

  @Expose() bookType: BookEnum

  @Expose() chapterPurchasedCount: number

  @Expose() isPermanentBan: boolean

  @Expose()
  @Type(() => CategoryType)
  category: CategoryType

  @Expose({ name: 'penName' })
  @Type(() => PenNameType)
  @Transform(({ value }) => value || {})
  penNameData: PenNameType

  @Expose()
  @Type(() => BookChapterPurchaseType)
  bookChapters: BookChapterPurchaseType[]

  penName: string

  categoryName: string

  categoryId: number

  avatarImgPath: string
}
